import { ProgramData } from '@tenants/types/tenant';
import {
  GTM_CLICK_BOOST_CANDIDATE_BUTTON_JOIN_EXP,
  GTM_CLICK_THRIVE_CANDIDATE_BUTTON_JOIN_EXP,
} from 'constants/events';
import { joinExpCaPaths, joinExpUsPaths, Namespaces } from 'types/locales';

export function createProgramData(namespace: typeof Namespaces.JOIN_EXP_US | typeof Namespaces.JOIN_EXP_CA) {

  const programs_boost_imageAlt: joinExpCaPaths | joinExpUsPaths = `${namespace}:programs.boost.imageAlt`;
  const programs_boost_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:programs.boost.title`;
  const programs_boost_description: joinExpCaPaths | joinExpUsPaths = `${namespace}:programs.boost.description`;
  const programs_boost_buttonText: joinExpCaPaths | joinExpUsPaths = `${namespace}:programs.boost.buttonText`;

  const programs_thrive_imageAlt: joinExpCaPaths | joinExpUsPaths = `${namespace}:programs.thrive.imageAlt`;
  const programs_thrive_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:programs.thrive.title`;
  const programs_thrive_description: joinExpCaPaths | joinExpUsPaths = `${namespace}:programs.thrive.description`;
  const programs_thrive_buttonText: joinExpCaPaths | joinExpUsPaths = `${namespace}:programs.thrive.buttonText`;

  const programsData: readonly ProgramData[] = [
    {
      image: '/next/assets/images/join-expus/program-3.jpeg',
      imageAlt: programs_boost_imageAlt,
      title: programs_boost_title,
      description: programs_boost_description,
      buttonText: programs_boost_buttonText,
      buttonLink: 'https://docs.google.com/forms/d/e/1FAIpQLScb_rXcHYN2yOY7VFAuG1UhvjTwpKRWteFsB_fZhnzsnBZTZg/viewform',
      buttonClickEvent: GTM_CLICK_BOOST_CANDIDATE_BUTTON_JOIN_EXP,
    },
    {
      image: '/next/assets/images/join-expus/program-4.jpeg',
      imageAlt: programs_thrive_imageAlt,
      title: programs_thrive_title,
      description: programs_thrive_description,
      buttonText: programs_thrive_buttonText,
      buttonLink: 'https://docs.google.com/forms/d/e/1FAIpQLSeIE4Y1gVhUACFa1DEj_qD0k-1zqWBKn8s6X3a1fCDpvXJodQ/viewform',
      buttonClickEvent: GTM_CLICK_THRIVE_CANDIDATE_BUTTON_JOIN_EXP,
    },
  ] as const;

  return programsData;
}